import { createApp } from 'vue'
import axios from 'axios'
import Personnummer from 'personnummer'
import countries from '../data/countries.json'
import phoneCodes from '../data/phone-codes.json'

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-register-user').forEach((el) => {
        const app = createApp({
            data() {
                return {
                    fieldPersonalNumber: '',
                    fieldEmail: '',
                    fieldEmailConfirm: '',
                    fieldFirstName: '',
                    fieldLastName: '',
                    fieldAddress: '',
                    fieldPhone: '',
                    fieldBirthDate: '',
                    formError: false,
                    formLoading: false,
                    result: false,
                    citizenshipDropdownOpen: false,
                    swedishCitizen: true,
                    init: false,
                    checkedUser: false,
                    userExists: false,
                    countries: countries,
                    phoneCodes: phoneCodes,
                    selectedCountry: {"id":752,"alpha2":"se","alpha3":"swe","name":"Sverige"},
                    countriesDropdownOpen: false,
                    countriesDropdownSearch: '',
                    bankIdPersonalNumber: '',
                    restBase: liGlobal.restBase,
                    authenticatedUser: false,
                    templateDirectory: liGlobal.templateDirectory,
                    qrCode: null,
                    bankIdInterval: null,
                    doingRegister: false,
                }
            },
            components: {
            },
            created() {
                this.init = true
            },
            computed: {
                filteredCountries: function() {
                    if( this.countriesDropdownSearch.length > 0 ) {
                        return this.countries.filter(country => country.name.toLowerCase().includes(this.countriesDropdownSearch.toLowerCase()));
                    } else {
                        return this.countries;
                    }
                },
                formattedFieldPersonalNumber: {
                    set: function(val) {
                        const number = val.replaceAll('-', '');
                        if( this.checkedUser === true ) {
                            this.checkedUser = false;
                            this.clearForm();
                        }

                        this.fieldPersonalNumber = number;
                    },
                    get: function() {
                        const number = this.fieldPersonalNumber;

                        if( number.length === 8 ) {
                            return number + '-';
                        }

                        if( number.length > 8 ) {
                            return number.substring(0,8) + '-' + number.substring(8);
                        } else {
                            return number;
                        }

                    },
                },
                normalizedPhone: function() {
                    if( this.fieldPhone.trim() === '' ) {
                        return '';
                    }

                    const phoneCountryCode = this.phoneCodes[this.selectedCountry.alpha2.toUpperCase()];
                    let phone = this.fieldPhone.trim();

                    if( phoneCountryCode === '46' && phone.charAt(0) === '0' ) {
                        phone = phone.substr(1);
                    }

                    return '+' + phoneCountryCode.toString() + phone;
                },
                formattedFieldBirthDate: {
                    set: function(val) {

                        if( val.length > this.fieldBirthDate.length ) {
                            if( val.length === 4 || val.length === 7 ) {
                                this.fieldBirthDate = val + '-';
                            } else {
                                this.fieldBirthDate = val;
                            }
                        } else  {
                            if( val.length === 7 ) {
                                this.fieldBirthDate = val.substring(0, 6);
                            } else if( val.length === 4 ) {
                                this.fieldBirthDate = val.substring(0, 3);
                            } else {
                                this.fieldBirthDate = val;

                            }

                        }

                    },
                    get: function() {
                        const number = this.fieldBirthDate;

                        if( number.length === 4 || number.length === 7 ) {
                            return number + '-';
                        }

                        return number;
                    },
                },
                formattedEmail: {
                    set: function(val) {
                        if( !this.swedishCitizen && this.checkedUser === true ) {
                            this.checkedUser = false;
                            this.clearForm();
                        }

                        this.fieldEmail = val;
                    },
                    get: function() {
                        return this.fieldEmail;
                    }
                }
            },
            methods: {
                selectCountry: function(value) {
                    this.selectedCountry = value;
                    this.countriesDropdownOpen = false;
                    this.countriesDropdownSearch = '';
                },
                selectCitizenship: function(type) {
                    this.citizenshipDropdownOpen = false;
                    if( this.swedishCitizen === type ) {
                        return;
                    }

                    if( this.checkedUser === true ) {
                        this.checkedUser = false;
                        this.clearForm();
                    }

                    this.fieldPersonalNumber = '';
                    this.fieldEmail = '';
                    this.fieldEmailConfirm = '';
                    this.swedishCitizen = type;
                },

                onlyNumber ($event) {
                    let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
                    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
                       $event.preventDefault();
                    }
                 },
                 onlyPersonalNumber ($event) {
                    if( $event.target.value.length > 12 ) {
                        $event.preventDefault();
                        return;
                    }
                    let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
                    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
                       $event.preventDefault();
                    }
                 },
                 onlyBirthDate ($event) {
                    if( $event.target.value.length > 9 ) {
                        $event.preventDefault();
                        return;
                    }
                    let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
                    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
                       $event.preventDefault();
                    }
                 },
                emailsMatch: function() {
                    return this.fieldEmail.trim().toLowerCase() === this.fieldEmailConfirm.trim().toLowerCase()
                },
                validateEmailConfirmation: function() {
                    if (this.fieldEmailConfirm.trim() === '') {
                        this.formError = { field: 'fieldEmailConfirm', message: 'bekräfta e-postadressen' }
                        return false
                    }

                    if (!this.emailsMatch()) {
                        this.formError = { field: 'fieldEmailConfirm', message: 'e-postadresserna matchar inte' }
                        return false
                    }

                    return true
                },
                clearForm: function() {
                    this.fieldFirstName = '';
                    this.fieldLastName = '';
                    this.fieldAddress = '';
                    this.fieldPhone = '';
                    this.result = false;
                },
                checkUserExists: function() {
                    if( this.formLoading == true ) {
                        return;
                    }
                    this.formError = false;
                    this.userExists = false;

                    const personalNumber = this.fieldPersonalNumber.trim();
                    const email = this.fieldEmail.trim();

                    const regexp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                    if( this.swedishCitizen === true ) {
                        if( personalNumber === '' ) {
                            this.formError = { field: 'fieldPersonalNumber', message: 'ange ett personnummer'};
                            return;
                        }

                        if( personalNumber.length !== 12 ) {
                            this.formError = { field: 'fieldPersonalNumber', message: 'ogiltigt personnummer, 12 siffror krävs.'};
                            return;
                        }

                        if( !Personnummer.valid(personalNumber) ) {
                            this.formError = { field: 'fieldPersonalNumber', message: 'ogiltigt personnummer'};
                            return;
                        }
                    } else {
                        if( email === '' ) {
                            this.formError = { field: 'fieldEmail', message: 'ange en e-postadress'};
                            return;
                        }

                        if( !regexp.test(email) ) {
                            this.formError = { field: 'fieldEmail', message: 'ogiltig e-postadress'};
                            return;
                        }

                        if( !this.validateEmailConfirmation() ) {
                            return;
                        }
                    }
                    this.formLoading = true;

                    let query;

                    if( this.swedishCitizen ) {
                        query = '?PersonalNumber=' + encodeURIComponent(personalNumber);

                        this.$http.get(this.restBase + '/softadmin-check-personal-number' + query, {
                            headers: { 'X-WP-Nonce': liGlobal.restNonce }
                        }).then((response) => {
                            this.formLoading = false;
                            if( response.data.Exists === false ) {
                                this.checkedUser = true;
                            } else {
                                this.userExists = true;
                            }
                        }).catch((error) => {
                            this.formLoading = false;
                            this.formError = { field: '', message: 'Kunde inte kontrollera personnummer. Försök igen.' };
                            console.log( error );
                        });
                    } else {
                        query = '?Email=' + encodeURIComponent(email);
                        this.$http.get(this.restBase + '/softadmin-check-email' + query, {
                            headers: { 'X-WP-Nonce': liGlobal.restNonce }
                        }).then((response) => {
                            this.formLoading = false;

                            if( response.data.Exists === false ) {
                                this.checkedUser = true;
                            } else {
                                this.userExists = true;
                            }
                        }).catch((error) => {
                            this.formLoading = false;
                            this.formError = { field: '', message: 'Kunde inte kontrollera e-post. Försök igen.' };
                            console.log( error );
                        });
                    }



                },
                authenticateAndRegisterUser: function (device) {
                    if (this.swedishCitizen === true) {

                        const userAgent = navigator.userAgent;

                        const isMobile = userAgent.includes('Mobi') ? 'true' : 'false';
                        const thisDevice = device === 'thisDevice' ? 'true' : 'false';

                        this.$http.post(this.restBase + '/bankid-federated-login', { isMobile: isMobile, thisDevice: thisDevice }).then((response) => {

                            const autoStartToken = response.data.autoStartToken;
                            const sessionId = response.data.sessionId;

                            if (!sessionId) {
                                this.formLoading = false;
                                this.formError = {
                                    field: 'fieldBankId',
                                    message: 'BankID start misslyckades. Försök igen.',
                                };
                                return;
                            }

                            if (device === 'thisDevice') {
                                if (userAgent.includes('Mobi')) {
                                    if ((userAgent.includes('Mac OS X') && userAgent.includes('Safari/') && !userAgent.includes('Chrome/') && !userAgent.includes('CriOS/')) || (userAgent.includes('Android') && userAgent.includes('Chrome')) || (userAgent.includes('Android') && userAgent.includes('CriOs'))) {
                                        document.location.href = 'https://app.bankid.com/?autostarttoken=' + autoStartToken + '&redirect=null';
                                    }
                                    else {
                                        document.location.href = 'bankid:///?autostarttoken=' + autoStartToken + '&redirect=null';
                                    }
                                }
                                else {
                                    document.location.href = 'bankid:///?autostarttoken=' + autoStartToken + '&redirect=null';
                                }
                            }
                            else {
                                this.qrCode = response.data.QRCode;
                            }

                            // Get BankID session
                            // Run a function every second for 165 seconds to check if user is authenticated
                            let i = 0;
                            this.bankIdInterval = setInterval(() => {
                                if (i > 165) {
                                    clearInterval(this.bankIdInterval);
                                    this.qrCode = null;
                                    this.formLoading = false;

                                    this.formError = { field: 'fieldBankId', message: 'Autentisering med BankID genomfördes inte. Försök igen.' };
                                    return;
                                }

                                this.$http.post(this.restBase + '/get-bankid-session', { sessionId: sessionId }).then((response) => {
                                    const data = response.data || {};
                                    const grand = data.grandidObject || {};
                                    const status = grand.message && grand.message.status;

                                    if( !this.formLoading ) {
                                        return;
                                    }

                                    if (device === 'otherDevice' && grand.QRCode) {
                                        this.qrCode = grand.QRCode;
                                    }

                                    if (status == 'failed') {
                                        clearInterval(this.bankIdInterval);

                                        this.qrCode = null;
                                        this.formLoading = false;

                                        this.formError = {
                                            field: 'fieldBankId',
                                            message: 'Autentisering med BankID genomfördes inte. Försök igen.',
                                        };
                                    }  else if ('userAttributes' in data) {
                                        clearInterval(this.bankIdInterval);
                                        this.qrCode = null;

                                        if (this.fieldPersonalNumber !== data.userAttributes.personalNumber) {
                                            this.formLoading = false;
                                            this.formError = { field: 'fieldPersonalNumber', message: 'Personnumret stämmer inte överens med BankID-autentiseringen.' };
                                            this.qrCode = null;
                                            return;
                                        }


                                        // Register user in Softadmin after successful authentication
                                        let dataPayload = {
                                            'FirstName': this.fieldFirstName,
                                            'LastName': this.fieldLastName,
                                            'Email': this.fieldEmail,
                                            'PersonalNumber': this.fieldPersonalNumber,
                                            'MobileNumber': this.normalizedPhone,
                                            'SessionId': sessionId,
                                        }


                                        if( !this.doingRegister ) {
                                            this.$http.post(this.restBase + '/softadmin-register-person', dataPayload, {
                                                headers: { 'X-WP-Nonce': liGlobal.restNonce }
                                            }).then((response) => {
                                                this.result = response.data;
                                                this.formLoading = false;
                                                this.doingRegister = false;
                                            }).catch((error) => {
                                                this.registerError = true;
                                                this.formError = { field: '', message: 'Kunde inte registrera användaren. Försök igen.' };
                                                this.formLoading = false;
                                                this.doingRegister = false;
                                            });
                                        }

                                        this.doingRegister = true;
                                    }
                                }).catch(() => {
                                });

                                i++;
                            }, 1000);

                        }).catch((error) => {
                            this.formLoading = false;
                            this.formError = {
                                field: 'fieldBankId',
                                message: 'Kunde inte starta BankID. Försök igen.',
                            };
                        });
                    }
                },
                validateFormAndRegisterUser: function (device) {
                    if( this.formLoading == true ) {
                        return;
                    }

                    this.result = false;

                    this.formError = false;
                    const regexp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                    this.fieldPersonalNumber = this.fieldPersonalNumber.trim();
                    this.fieldFirstName = this.fieldFirstName.trim();
                    this.fieldLastName = this.fieldLastName.trim();
                    this.fieldEmail = this.fieldEmail.trim();
                    this.fieldEmailConfirm = this.fieldEmailConfirm.trim();
                    this.fieldPhone = this.fieldPhone.trim();
                    this.fieldBirthDate = this.fieldBirthDate.trim();

                    if( this.swedishCitizen ) {
                        if( this.fieldFirstName === '' ) {
                            this.formError = { field: 'fieldFirstName', message: 'ange förnamn'};
                            return;
                        }

                        if( this.fieldLastName === '' ) {
                            this.formError = { field: 'fieldLastName', message: 'ange efternamn'};
                            return;
                        }

                        if( this.fieldEmail === '' ) {
                            this.formError = { field: 'fieldEmail', message: 'ange en e-postadress'};
                            return;
                        }

                        if( !regexp.test(this.fieldEmail) ) {
                            this.formError = { field: 'fieldEmail', message: 'ogiltig e-postadress'};
                            return;
                        }

                        if( !this.validateEmailConfirmation() ) {
                            return;
                        }
                    } else {
                        if( this.fieldBirthDate === '' ) {
                            this.formError = { field: 'fieldBirthDate', message: 'ange födelsedatum'};
                            return;
                        }

                        if( this.fieldBirthDate.length !== 10 ) {
                            this.formError = { field: 'fieldBirthDate', message: 'ogiltigt födelsedatum'};
                            return;
                        }

                        if( this.fieldFirstName === '' ) {
                            this.formError = { field: 'fieldFirstName', message: 'ange förnamn'};
                            return;
                        }

                        if( this.fieldLastName === '' ) {
                            this.formError = { field: 'fieldLastName', message: 'ange efternamn'};
                            return;
                        }

                        if( !this.validateEmailConfirmation() ) {
                            return;
                        }
                    }


                    this.formLoading = true;

                    if (this.swedishCitizen) {
                        this.authenticateAndRegisterUser(device)
                    }
                    else {
                        let data = {
                            'FirstName': this.fieldFirstName,
                            'LastName': this.fieldLastName,
                            'Email': this.fieldEmail,
                            'DateBirth': this.fieldBirthDate,
                            'MobileNumber': this.normalizedPhone,
                        }

                        this.$http.post(this.restBase + '/softadmin-register-person', data, {
                            headers: { 'X-WP-Nonce': liGlobal.restNonce }
                        }).then((response) => {
                            this.result = response.data;
                            this.formLoading = false;
                        }).catch((error) => {
                            console.log( error );
                            this.registerError = true;
                            this.formError = { field: '', message: 'Kunde inte registrera användaren. Försök igen.' };
                            this.formLoading = false;
                        });
                    }
                },
                cancelBankId: function() {
                    clearInterval(this.bankIdInterval);
                    this.qrCode = null;
                    this.formLoading = false;
                },
            },

        })

        app.config.globalProperties.$http = axios
        app.config.globalProperties.axios = axios
        app.mount(el)
    })
})
